export default __webpack_public_path__ + "static/media/next-not-clicked-green.a0230df7.svg";